// extracted by mini-css-extract-plugin
export default {"form":"CompanyCheck_form__cgg9o","header":"CompanyCheck_header__Ad88+","input":"CompanyCheck_input__2KaXo"};